import React from 'react'

const Rear = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 716" xmlSpace="preserve" width={width} height={height}>
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	35.238,224.291 35.238,699.761 926.329,699.761 926.329,220.966 "
    />
    <line fill="none" stroke={color} strokeWidth="18.703" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="158.262" y1="19.806" x2="803.305" y2="19.806" />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M224.345,443.739c0,0,33.665,9.975,19.95-19.95c-13.715-29.925-29.925-59.849-36.159-69.824
	c-6.234-9.975-8.728-16.209-24.937-18.703s-47.381-8.728-77.305-14.962c-12.744-2.655-32.418-21.197-38.653-3.741
	c-6.234,17.456-9.975,57.356-9.975,63.59c0,6.234,0,18.703,27.431,27.431C112.128,416.308,208.136,439.998,224.345,443.739z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M120.856,319.053c0,0-23.69-42.393-2.494-69.824"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M319.948,197.982c-8.926,0-25.155-5.985-25.155-20.199s0.811-23.192,1.623-29.177c0.811-5.985,6.492-13.466,18.663-13.466
	c12.172,0,31.646,0,40.572,0c9.737,0,15.417,5.237,16.229,11.97c1.74,14.437,3.246,23.192,3.246,32.169s-7.303,19.451-21.097,19.451
	C341.857,198.73,319.948,197.982,319.948,197.982z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M339.488,133.919c0.311-5.368,0.751-9.496,1.191-12.743c0.811-5.985,6.492-13.466,18.663-13.466c12.172,0,31.646,0,40.572,0
	c9.737,0,15.417,5.237,16.229,11.97c1.74,14.437,3.246,23.192,3.246,32.169c0,8.977-7.303,19.451-21.097,19.451
	c-6.521,0-15.837-0.215-23.082-0.414"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M398.292,171.299c0,0,38.644-4.364,41.761,15.586c1.255,8.031,2.494,13.092,2.494,13.092"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M901.112,402.592c0,0,32.418,183.289-47.381,233.163c-79.799,49.875-320.444,42.393-367.824,42.393h-9.695
	c-47.381,0-288.025,7.481-367.824-42.393c-79.799-49.874-47.381-233.163-47.381-233.163"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M737.773,443.739c0,0-33.665,9.975-19.95-19.95c13.715-29.925,29.925-59.849,36.159-69.824c6.234-9.975,8.728-16.209,24.937-18.703
	s47.381-8.728,77.305-14.962c12.744-2.655,32.418-21.197,38.653-3.741c6.234,17.456,9.975,57.356,9.975,63.59
	c0,6.234,0,18.703-27.431,27.431C849.99,416.308,753.982,439.998,737.773,443.739z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M841.262,319.053c0,0,23.69-42.393,2.494-69.824"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M797.622,432.517c0,0-13.716,49.875-74.812,58.603s-207.738,9.975-241.403,9.975h-1.039c-33.665,0-179.964-1.247-241.06-9.975
	s-74.812-58.603-74.812-58.603"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M782.66,486.132c-8.728,13.715-23.69,24.937-43.64,26.184c-19.95,1.247-238.299,9.585-257.275,9.585
	c-1.352,0-1.377,0.078-3.247,0.078c-132.375,0-235.449-8.416-255.399-9.663c-19.95-1.247-34.912-12.469-43.64-26.184"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M788.894,199.354c0,0,6.234,21.197-27.431,26.184c-33.665,4.987-152.117,12.469-279.297,12.469h-2.214
	c-127.18,0-245.632-7.481-279.297-12.469c-33.665-4.987-27.431-26.184-27.431-26.184"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M712.835,88.383c0,0-40.018-18.717-72.318-22.444c-32.418-3.741-78.552-6.234-158.352-6.234h-2.214
	c-79.799,0-125.933,2.494-158.352,6.234c-32.3,3.727-72.318,22.444-72.318,22.444"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M642.17,197.982c8.926,0,25.155-5.985,25.155-20.199s-0.811-23.192-1.623-29.177c-0.811-5.985-6.492-13.466-18.663-13.466
	c-12.172,0-31.646,0-40.572,0c-9.737,0-15.417,5.237-16.229,11.97c-1.74,14.437-3.246,23.192-3.246,32.169
	s7.303,19.451,21.097,19.451C620.261,198.73,642.17,197.982,642.17,197.982z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M622.63,133.919c-0.311-5.368-0.751-9.496-1.191-12.743c-0.811-5.985-6.492-13.466-18.663-13.466c-12.172,0-31.646,0-40.572,0
	c-9.737,0-15.417,5.237-16.229,11.97c-1.74,14.437-3.246,23.192-3.246,32.169c0,8.977,7.303,19.451,21.097,19.451
	c6.521,0,15.838-0.215,23.082-0.414"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M563.826,171.299c0,0-38.644-4.364-41.761,15.586c-1.255,8.031-2.494,13.092-2.494,13.092"
    />
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	748.994,200.601 481.199,203.094 480.576,203.094 213.124,200.601 "
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M882.409,306.584c0,0-8.728-34.912-19.95-44.887c-11.222-9.975-56.149-34.255-76.059-74.812
	c-33.665-68.577-96.008-119.699-96.008-119.699c-36.159-29.925-208.226-27.015-208.226-27.015h-2.214
	c0,0-172.067-2.909-208.226,27.015c0,0-62.343,51.121-96.008,119.699c-19.91,40.557-64.837,64.837-76.059,74.812
	c-11.222,9.975-19.95,44.887-19.95,44.887"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M482.162,474.91c11.222,0,88.527,0,110.971-3.741c22.444-3.741,42.393-11.222,53.615-36.159
	c11.222-24.937,16.209-52.368,17.456-62.343c1.247-9.975-1.247-13.715-14.962-11.222c-13.715,2.494-83.54,9.975-167.08,9.975h-3.457
	c-83.54,0-153.364-7.481-167.08-9.975c-13.715-2.494-16.209,1.247-14.962,11.222c1.247,9.975,6.234,37.406,17.456,62.343
	c11.222,24.937,31.172,32.418,53.615,36.159c22.444,3.741,99.749,3.741,110.971,3.741H482.162z"
    />
  </svg>
)
export default Rear
